import base_config from "./base_config";

const dev_config = {
  ...base_config,
  STAGE: "dev",

  // Amplify config for cognito
  AMPLIFY_CONFIG: {
    aws_project_region: base_config.REGION,
    aws_cognito_region: base_config.REGION,
    aws_user_pools_id: "us-west-2_98VCRNfCo",
    aws_user_pools_web_client_id: "6utmd5dcgqb781q9q4urlkvv8i",
    cookieStorage: {
      domain: window.location.hostname,
    },
    oauth: {
      domain: "wise-general-cog-dev.auth.us-west-2.amazoncognito.com",
      scope: base_config.TOKEN_SCOPES_ARRAY,
      redirectSignIn: base_config.CALL_BACK_URL,
      redirectSignOut: base_config.CALL_BACK_URL,
      responseType: base_config.OAUTH_RESPONSE_TYPE,
    },
  },

  BASE_URL: "https://cq6kjt1xmf.execute-api.us-west-2.amazonaws.com/dev",
  ENGINEERING_URL: "https://ldd5idcog4.execute-api.us-west-2.amazonaws.com/dev",
  UPLOAD_BASE_URL: "https://wrcqb3byf5.execute-api.us-west-2.amazonaws.com/dev",

  ENGINEERING_WEBSITE: "https://beta.lens-engineering.lab126.amazon.dev",
};

export default dev_config;
